"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var propTypes = _interopRequireWildcard(require("./mini-dealer-locator.prop-types"));
var _inputMessages = _interopRequireDefault(require("./input-messages.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var isTypeError = function isTypeError(type) {
  return type === 'error';
};
var isTypeInfo = function isTypeInfo(type) {
  return type === 'info';
};
var InputMessages = function InputMessages(_ref) {
  var messages = _ref.messages,
    theme = _ref.theme;
  if (!Array.isArray(messages)) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, messages.map(function (_ref2) {
    var _clsx, _clsx2;
    var body = _ref2.body,
      type = _ref2.type;
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: body,
      className: (0, _clsx3["default"])(_inputMessages["default"].body, (_clsx = {}, _clsx[_inputMessages["default"].error] = isTypeError(type), _clsx[_inputMessages["default"].info] = isTypeInfo(type), _clsx))
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: (0, _clsx3["default"])((_clsx2 = {}, _clsx2[theme.mmcIconFormError] = isTypeError(type), _clsx2[theme.mmcIconTooltip] = isTypeInfo(type), _clsx2))
    }), body);
  }));
};
var _default = InputMessages;
exports["default"] = _default;